import { ACCOUNT_TYPE } from '../../../constants/PaymentTypes';
export var fireCallbackForPaymentTypes = function fireCallbackForPaymentTypes(accountType) {
  return accountType !== ACCOUNT_TYPE.CREDIT_CARD && accountType !== ACCOUNT_TYPE.VENMO;
};

/**
 * Called by CreateMop listener to determine if it should fire the FETCH_PAYMENT_METHOD callback.
 * If this callback is fired, the order will be placed automatically by the PLACE_ORDER_THROUGH_SDK
 * command in the Drop In Payments package
 * @param paymentMethods the current payment methods on file
 * @param showSubmitButton config var
 * @param accountType the type of payment method
 */
export var shouldFireCallbackCommands = function shouldFireCallbackCommands(paymentMethods, showSubmitButton, accountType) {
  /**
   * If the account type is GooglePay, immediately return false
   * since there will not be a mop on file yet and we also don't
   * want to automatically place the order yet.
   */
  if (accountType === ACCOUNT_TYPE.GOOGLE_PAY) {
    return false;
  }

  /**
   * Only fire callbacks when either:
   * 1. The user has no MOPs on file.
   * 2. The user is submitting through a non-credit card or non-venmo.
   */
  return paymentMethods.length === 0 && !showSubmitButton || fireCallbackForPaymentTypes(accountType);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/shouldFireCallbackCommands.js
// module id = 4393
// module chunks = 11